"use client";

import type { ReactNode } from "react";
import { cn } from "@/modern/utils";
import type { ImageFrameRect } from "../hooks/useObjectContainImageFrame";

type AnalyzeImageFrameLayerProps = {
  frame: ImageFrameRect;
  zClassName?: string;
  className?: string;
  ariaLive?: "polite" | "off";
  children: ReactNode;
};

/** Positions children over the visible object-contain image bounds. */
export const AnalyzeImageFrameLayer = ({
  frame,
  zClassName = "z-20",
  className,
  ariaLive = "polite",
  children,
}: AnalyzeImageFrameLayerProps) => (
  <div
    className={cn("pointer-events-none absolute overflow-hidden rounded-md", zClassName, className)}
    style={{
      top: frame.top,
      left: frame.left,
      width: frame.width,
      height: frame.height,
    }}
    aria-live={ariaLive}
  >
    {children}
  </div>
);
